
import React, { useState } from 'react';
import { api } from '../services/api';

export default function TwoFactorSetup({ user, onUpdate }) {
    const [step, setStep] = useState('initial'); // initial, verify
    const [token, setToken] = useState('');
    const [msg, setMsg] = useState('');
    const [loading, setLoading] = useState(false);

    const isEnabled = user?.isTwoFactorEnabled;

    const startSetup = async () => {
        setLoading(true);
        setMsg('');
        try {
            // Trigger setup to generate OTP and email it
            await api.setup2FA();
            setStep('verify');
            setMsg('✅ Check your email for a verification code.');
        } catch (err) {
            setMsg(err.message || 'Failed to start 2FA setup');
        } finally {
            setLoading(false);
        }
    };

    const verifySetup = async () => {
        setLoading(true);
        setMsg('');
        try {
            // Verify the OTP entered by user
            await api.verify2FA(token);
            setMsg('✅ 2FA Enabled Successfully! Future logins will require an email code.');
            setStep('initial');
            setToken('');
            if (onUpdate) onUpdate(true);
        } catch (err) {
            setMsg(err.message || 'Invalid code');
        } finally {
            setLoading(false);
        }
    };

    const disable2FA = async () => {
        if (!window.confirm('Are you sure you want to disable 2FA? This will decrease your account security.')) return;
        setLoading(true);
        setMsg('');
        try {
            await api.disable2FA();
            setMsg('2FA Disabled.');
            if (onUpdate) onUpdate(false);
        } catch (err) {
            setMsg(err.message || 'Failed to disable 2FA');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ padding: '20px', border: '1px solid #ddd', borderRadius: '8px', marginTop: '20px', maxWidth: '400px' }}>
            <h3>Two-Factor Authentication (2FA)</h3>

            {msg && <p style={{ color: msg.includes('✅') ? 'green' : 'crimson', marginBottom: '10px' }}>{msg}</p>}

            {isEnabled ? (
                <div>
                    <p style={{ color: 'green', fontWeight: 'bold' }}>✅ 2FA is currently ENABLED</p>
                    <p style={{ fontSize: '0.9em', color: '#666' }}>We will send a code to your email when you log in.</p>
                    <button
                        onClick={disable2FA}
                        disabled={loading}
                        style={{
                            backgroundColor: '#ff4d4f', color: 'white', padding: '8px 16px',
                            border: 'none', borderRadius: '4px', cursor: 'pointer'
                        }}
                    >
                        {loading ? 'Disabling...' : 'Disable 2FA'}
                    </button>
                </div>
            ) : (
                <div>
                    <p>Secure your account with Email 2FA. We will email you a code to verify it's you.</p>

                    {step === 'initial' && (
                        <button
                            onClick={startSetup}
                            disabled={loading}
                            style={{
                                backgroundColor: '#1890ff', color: 'white', padding: '8px 16px',
                                border: 'none', borderRadius: '4px', cursor: 'pointer'
                            }}
                        >
                            {loading ? 'Sending Code...' : 'Enable 2FA via Email'}
                        </button>
                    )}

                    {step === 'verify' && (
                        <div style={{ marginTop: '15px' }}>
                            <p>Enter the code sent to your email:</p>
                            <input
                                type="text"
                                value={token}
                                onChange={(e) => setToken(e.target.value)}
                                placeholder="123456"
                                style={{ padding: '8px', width: '100%', marginBottom: '10px', fontSize: '1.2em', textAlign: 'center', letterSpacing: '4px' }}
                            />
                            <div style={{ display: 'flex', gap: '10px' }}>
                                <button
                                    onClick={verifySetup}
                                    disabled={loading || token.length < 6}
                                    style={{
                                        backgroundColor: '#52c41a', color: 'white', padding: '8px 16px',
                                        border: 'none', borderRadius: '4px', cursor: 'pointer', flex: 1
                                    }}
                                >
                                    {loading ? 'Verifying...' : 'Verify & Enable'}
                                </button>
                                <button
                                    onClick={() => setStep('initial')}
                                    style={{
                                        backgroundColor: '#999', color: 'white', padding: '8px 16px',
                                        border: 'none', borderRadius: '4px', cursor: 'pointer'
                                    }}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}
